export const FirearmOwnerConstants = {
    MY_FIREARM: 'b862356e-2e8d-4118-bbc6-6d4c2413ad27',
    SOMEONE_ELSES_FIREARM: '851522d3-f53f-4717-a463-89d63c26964b'
};